<!-- Ported from the Polaris kit: src/components/ui/badge/Badge.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { reactiveOmit } from '@vueuse/core';
import { Primitive } from 'reka-ui';
import { cn } from '../../lib/utils';
import { badgeVariants } from '.';

const props = defineProps({
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  variant: { type: null, required: false },
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});

const delegatedProps = reactiveOmit(props, 'class');
</script>

<template>
  <Primitive
    data-slot="badge"
    :class="cn(badgeVariants({ variant }), props.class)"
    v-bind="delegatedProps"
  >
    <slot />
  </Primitive>
</template>
